
import { createHTMLMapMarker } from './html-map-marker'
import ListUtil from '../pricetravel/list/utils';
import { getHeaders } from '../pricetravel/shared/tokenUtil';
import { AMENITIES_DESCRIPTIONS } from '../../utils/pricetravel/shared/cardService'

export default class GoogleMapList {


    constructor(model, http, filter, scope, userKeyFac) {
        let config = window.__pt.settings.site;
        this.vm = model;
        this.http = http;
        this.filter = filter;
        this.scope = scope;
        this.fn = window.__pt.fn;
        this.config = window.__pt.settings.site;
        this.settings = window.__pt.settings;
        this.box = window.__pt.box;
        this.markers = [];
        this.params = {};
        this.paramsRates = {};
        this.paramsFilter = {};
        this.paxes = {};
        this.map = null;
        this._userKeyFac = userKeyFac;
        this.showServices = config.showServices;
    }

    initialize() {
        this.hotels = [];
        this.rates = [];
        this.itemsHotel = null;
        this.vm.showMapDetail = false;
        this.vm.detailCardMap = {};
        this.vm.loading_refresh_map = null;
        if(this.onRenderMap()) {
            this.getHotels();
        }
        this.clearMarkers();
    }

    openMap(params, paramsRates, paxes, campaignToken, paramsFilter) {
        $(`#modal-mapsearch`).modal("show");
        this.params = params;
        this.paramsRates = paramsRates;
        this.paxes = paxes;
        this.campaignToken = campaignToken;
        this.paramsFilter = paramsFilter;
        this.initialize();
        this._listUtil = new ListUtil(params, this.config, "...");

    }


    async getHotels() {
        this.vm.loading = true;
        let paramsClone = this.fn.clone(this.paramsFilter);
        let pax = this.paxes.paxesFormat.join("/");
        let headers = getHeaders();


        paramsClone.page = 1;
        paramsClone.pageSize = this.config.listItemsMapCount;
        paramsClone.filters = this.vm.filtersSelectedArrayString.join(",");
        paramsClone.filters = this.vm.filtersSelectedArrayString.join(",");
        paramsClone.filtersCustom = this.vm.filterCustomList.map(f => f.uri).join(",");


        let response = await this.http.get(this.config.endPoints.filterUrl, { params: paramsClone, headers: headers });
        if (response && response.data && response.data.hotels) {
            this.hotels = response.data.hotels;
            this.vm.pagination.totalHotels = response.data.totalHotels;
            this.vm.onLoadFilters(response.data.filterGroups);
            this.vm.hotelFilters.filterCustoms.filterGroups = this._listUtil.setIsSelectCustomFilter(response.data.filterCustoms.filterGroups)
        }
        this.vm.loading = false;
        this.getRates();
    }


    async getRates() {
        this.vm.loading_refresh_map = true;

        this.scope.$apply(() => {
            this.vm.no_result_map = true;
        })

        this.createUrlDetail();
        this.centerMap();
        this.scope.$apply(() => {
            this.vm.loading_refresh_map = false;
        })
    };


    createUrlDetail() {
        let lengthHotel = this.hotels.length;
        let pax = this.fn.mapPaxToUrl(this.box.pax);
        let paramsUri = {
            checkin: this.box.checkIn,
            checkout: this.box.checkOut,
        };

        paramsUri = { ...paramsUri, ...pax };

        if (this.campaignToken) {
            paramsUri.CampaignToken = this.campaignToken;
        }

        let query = this.fn.objectToQueryParams(paramsUri);

        for (let i = 0; i < lengthHotel; i++) {

            let hotel = this.hotels[i];
            hotel.url = `${this.config.siteUrl}${this.config.pathHotelDetail}${hotel.uri}?${query}`;;
        }
    }


    onRenderMap() {
        let coords = { lat: 35.275, lng: -96.624 };
        if ('google' in window && google.maps) {
            this.initializeGoogleMap(coords, 4);
            return true;
        } else {
            this.fn.getScript(this.config.endPoints.googleMapsApi, "", () => {
                this.initializeGoogleMap(coords, 4);
                this.getHotels();
            });
        }
        return false;
    }


    async centerMap() {
        this.itemsHotel = [];
        this.updateHotelTags(this.hotels);
        let points = this.hotels
            .filter(h => h.price)
            .map(h => {
                const lat = parseFloat(h.locationInfo.latitude);
                const lon = parseFloat(h.locationInfo.longitude);
                this.itemsHotel.push({
                    id: h.hotelId,
                    url: h.url,
                    name: h.name,
                    price: h.price,
                    name: h.name,
                    latitude: lat,
                    longitude: lon,
                    cloudUri: h.mainPhoto.cloudUri+ "?tx=w_300,h_300",
                    stars: Math.round(h.stars),
                    surveyAverage: h.surveyAverage,
                    highlightedAttributes: h.highlights,
                    showPromotion: h.showPromotion,
                    showHotSBlackFri: h.showHotSBlackFri,
                    taxes: h.taxes,
                    services: h.services
                });
                return { latitude: lat, longitude: lon };
            });
    
        if (points.length === 0) {
            console.error('No valid points found for centering the map.');
            return;
        }

        const center = calculatePercentile50(points);
        await this.vm.getUSersFavorites();
        this.initializeMap(center.latitude, center.longitude, this.itemsHotel);
    
        this.scope.$apply(() => {
            this.vm.no_result_map = this.itemsHotel.length;
        });
    
        function calculatePercentile50(coordinates) {
            const percentileIndex = Math.floor(0.5 * coordinates.length);
            coordinates.sort((a, b) => a.longitude - b.longitude);
            const percentileLong = coordinates[percentileIndex];
            coordinates.sort((a, b) => a.latitude - b.latitude);
            const percentileLat = coordinates[percentileIndex];
            const avgLat = (percentileLat.latitude + percentileLong.latitude) / 2;
            const avgLng = (percentileLat.longitude + percentileLong.longitude) / 2;
            return new LatLng(avgLat, avgLng);
        }
    
        function LatLng(latitude, longitude) {
            this.latitude = latitude;
            this.longitude = longitude;
        }
    }
    


    initializeMap(latMid, lonMid, hotelsMap) {
        const center = { lat: latMid, lng: lonMid };
        this.initializeGoogleMap(center);

        this.markers = hotelsMap.map((h) => {
            const latLng = new google.maps.LatLng(h.latitude, h.longitude);
            let marker = createHTMLMapMarker({
                latlng: latLng,
                map: this.map,
                id: h.id,
                uri: h.uri,
                wellId: h.id,
                name: h.name,
                price: h.price,
                discount: h.discount,
                beforePromo: h.beforePromo,
                tax: h.taxPerRoomPerNight,
                cloudUri: h.cloudUri,
                stars: Math.round(h.stars),
                surveyAverage: h.surveyAverage,
                highlightedAttributes: h.highlightedAttributes,
                showPromotion: h.showPromotion,
                showHotSBlackFri: h.showHotSBlackFri,
                url: h.url,
                taxes: h.taxes,
                html: `<div id="hotel_bubble_${h.id}" class="speech-bubble">
                    ${this.vm.isFavoriteHotel(h.id) ? ' <i class="icons-heart d-inline-flex"></i>': ''}
                    ${this.filter('currency')(h.price, this.config.currencySymbol, 0)} 
                </div>`
            });

            marker.addListener('click', () => {
                
                this.clearBubble();
                $(`#hotel_bubble_${h.id}`).addClass("speech-bubble-active")
                this.vm.showMapDetailCard = this.vm.detailCardMap.show ? true: false;
                this.scope.$apply(() => {
                    this.vm.detailCardMap.id = marker.id;
                    this.vm.detailCardMap.name = marker.name;
                    this.vm.detailCardMap.stars = marker.stars;
                    this.vm.detailCardMap.cloudUri = h.cloudUri;
                    this.vm.detailCardMap.surveyAverage = marker.surveyAverage;
                    this.vm.detailCardMap.price = marker.price;
                    this.vm.detailCardMap.discount = marker.discount;
                    this.vm.detailCardMap.beforePromo = marker.beforePromo;
                    this.vm.detailCardMap.taxPerRoomPerNight = marker.tax;
                    this.vm.detailCardMap.showPromotion = marker.showPromotion;
                    this.vm.detailCardMap.showHotSBlackFri = marker.showHotSBlackFri;
                    this.vm.detailCardMap.highlights = marker.highlightedAttributes;
                    this.vm.detailCardMap.url = h.url;
                    this.vm.detailCardMap.taxes = h.taxes;
                    this.vm.detailCardMap.isFavorite = this.vm.isFavoriteHotel(marker.id);
                    this.vm.detailCardMap.show = true;
                    this.vm.detailCardMap.services = h.services;
                    setTimeout(() => {
                        $("#image-map-card").css('background-image', 'url(' + h.cloudUri + ')');
                    }, 200)
                    
                });
            });
            return marker;
        });

    }

    clearMarkers() {
        let length = this.markers.length;
        for (var i = 0; i < length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = new Array();
    }

    clearBubble() {
        $(".speech-bubble.speech-bubble-active").removeClass('speech-bubble-active');
    }

    initializeGoogleMap(center = {}, zoom = 12) {
        this.map = new window.google.maps.Map(document.getElementById('map'), {
            zoom: zoom,
            center: center,
            disableDefaultUI: true,
            zoomControl: true,
            gestureHandling: "greedy",
            styles: [
                {
                    featureType: "poi.business",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                }
            ],
        });
    }

    updateHotelTags(hotels) {
        hotels.forEach(hotel => {
            if (hotel.services && Array.isArray(hotel.services)) {
                hotel.services = hotel.services
                .map(service => this.findReviewByText(service.name))
                .filter(Boolean)
                .sort((a, b) => a.order - b.order)
                .reduce((acc, current) => {
                    if (!acc.some(service => service.order === current.order)) {
                        acc.push(current);
                    }
                    return acc;
                }, [])
                .slice(0, 3)
                .map(service => {
                    if (service.order === 1) {
                        service.text = 'Wi-fi';
                    }
                    return service;
                });
            }
        }); 
    }

    findReviewByText(text) {
        if (!text) return null; 
    
        const lowerText = text.toLocaleLowerCase();
        
        for (const [key, review] of Object.entries(AMENITIES_DESCRIPTIONS)) {
            const reviewEs = review.es?.toLocaleLowerCase() || '';
            const reviewEn = review.en?.toLocaleLowerCase() || '';
            
            if (reviewEs.includes(lowerText) || reviewEn.includes(lowerText)) {
                return { 
                    key,
                    text: this.config.language === "es" ? review.es : review.en, 
                    ...review 
                };
            }
        }
        
        return null;
    }

}